import { render, staticRenderFns } from "./SideNavProfile.vue?vue&type=template&id=4b259633"
import script from "./SideNavProfile.vue?vue&type=script&lang=js"
export * from "./SideNavProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports